<template>
  <div class="card-apontamento-historico">
    <div class="duracao">
      {{ getDuracao(apontamento.qtde) }}
    </div>
    <div class="info">
      <div class="cliente">
        {{ apontamento.cliente }}
      </div>
      <a 
        class="tarefa" 
        v-if="apontamento.issue"
        :href="getUrlGitlab(apontamento)" 
        :title="`Abrir no GitLab - ${getUrlGitlab(apontamento)}`" 
        target="_blank" 
      >
        {{ apontamento.tarefa }}
      </a>
      <div class="descricao">
        {{ apontamento.descricao }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-apontamento-historico {
  background-color: white;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 1px 1px 4px 0px #b7b7b7;
  margin: 10px 0;
  display: flex;

  .duracao {
    font-weight: bold;
    padding-right: 5px;
    border-right: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 50px;
    margin-right: 5px;
  }

  .info {
    .cliente {
      font-weight: bold;
    }
  }
}
</style>

<script>
import Uteis from '@/mixins/utils.js';

export default {
  name: 'CardApontamento',

  mixins: [
    Uteis,
  ],

  props: {
    apontamento: {
      type: Object,
      default: {},
    },
  },

  methods: {
    getUrlGitlab(apontamento) {
      const url = `http://gitlab.meta.com.br/${apontamento.path}/`;
      const projeto = apontamento.project_path ? `${apontamento.project_path}/` : '';
      const issue = apontamento.issue ? `issues/${apontamento.issue}` : '';

      return `${url}${projeto}${issue}`;
    },
  }
}
</script>